export default "__VITE_ASSET__AaQOjUVa__"